import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Center, Loader, Text, Stack } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import Fetch from '@/utils/Fetch';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import { createFileRoute } from '@tanstack/react-router'



const FeedbearRedirect = () => {
  const router = useRouter();
  const [status, setStatus] = useState<'checking' | 'redirecting' | 'error'>('checking');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const { refetch } = useQuery({
    queryKey: ['feedbear-token'],
    queryFn: () => Fetch.get({ url: '/feedbear/fbsessiontoken' }),
    enabled: false,
  });

  useEffect(() => {
    const handleFeedbearSSO = async () => {
      const hasToken = Storage.hasCookieValue(Enums.Cookie.token);

      if (!hasToken) {
        router.replace('/login?redirect=' + encodeURIComponent('/feedbear'));
        return;
      }

      setStatus('redirecting');

      try {
        const { data: response } = await refetch();

        if (response?.fbsessiontoken) {
          window.location.href = `https://servcraft.feedbear.com/sso/auth?payload=${response.fbsessiontoken}`;
        } else {
          setStatus('error');
          setErrorMessage('Unable to connect to Feedbear.');
        }
      } catch (error) {
        setStatus('error');
        setErrorMessage('An error occurred while connecting to Feedbear.');
      }
    };

    handleFeedbearSSO();
  }, [router, refetch]);

  return (
    <Center style={{ width: '100vw', height: '100vh', background: '#f8f9fa' }}>
      <Stack align="center" gap="md">
        {status === 'redirecting' && (
          <>
            <Loader size="lg" />
            <Text size="lg" fw={500}>Connecting to Feedbear...</Text>
          </>
        )}

        {status === 'error' && (
          <>
            <Text size="lg" fw={500} c="red">Error</Text>
            <Text size="sm" c="dimmed">{errorMessage}</Text>
            <Text
              size="sm"
              c="blue"
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => router.push('/')}
            >
              Return to Dashboard
            </Text>
          </>
        )}
      </Stack>
    </Center>
  );
};

export default FeedbearRedirect;

export const Route = createFileRoute('/_authenticated/feedbear')({ component: FeedbearRedirect })
